import { Tab, Tabs } from '@mui/material';
import React, { useEffect, useRef, useState } from "react";
import "react-circular-progressbar/dist/styles.css";
import { useLocation, useNavigate } from "react-router-dom";
import { styled } from '@mui/system';
import axios from 'axios';
import useAvailableHeight from "../../Custom/UseAvailableHeight";
import { useUserDetailContext } from "../../UserDetailContext";
import useApi from "../../Utilities/useAPI";
import HomepageMiddleFeed from "./HomepageMiddleFeed";
import HomepageLeftFeedd from './HomepageLeftFeedd';
import HomepageRightFeedd from './HomepageRightFeedd';
import { useDispatch, useSelector } from 'react-redux';
import { userOnboardByCreateLinkReducer } from "../../../Redux/Reducers/EnterpriseReducer";
import { setDeeplinking } from '../../../Redux/Reducers/OnboardingReducer';

const ParentHomePage = () => {
    const dispatch = useDispatch();
    const navigate = useNavigate()
    const apiKey = process.env.REACT_APP_API_KEY;
    const { userDetails } = useUserDetailContext();
    const location = useLocation();
    const searchParams = new URLSearchParams(location.search);
    let objectId = searchParams.get("objectId");
    const deeLinkURLPath = useSelector((state) => state?.onboarding?.deeplinkURL);
    const backLinkUrl = deeLinkURLPath?.split('back_link_url=')?.[1];
    const GetAadharData = useSelector((state) => state?.Kyc?.verifiedGetData?.data?.aadharData);
    const PanGetData = useSelector((state) => state?.Kyc?.verifiedGetData?.data?.panData);
    const isVerified = (value) => value !== "Not verified Yet" && value !== undefined && value !== null;
    // console.log("GetAadharData78958", GetAadharData, PanGetData)
    const isOnboarding = backLinkUrl?.includes('/onboarding');
    const isUniversityOnboarding = backLinkUrl?.includes('/university-onboarding');
    const hasOnboardingPath = isOnboarding || isUniversityOnboarding;
    const isKYCVerified = isVerified(GetAadharData) && isVerified(PanGetData)
    // console.log("deeLinkURLPath852", isOnboarding, isUniversityOnboarding, hasOnboardingPath, isKYCVerified)
    // console.log("deeLinkURLPath5656", deeLinkURLPath)
    useEffect(() => {
        // Check if user is on onboarding path AND KYC is not verified
        if (hasOnboardingPath && !isKYCVerified) {
            window.location.reload();
            navigate("/verify-docs", {
                state: { docType: 'Aadhaar' },
                replace: true
            })

        }
    }, [hasOnboardingPath, isKYCVerified, navigate]);


    if (!objectId) {
        // If objectId is not found in URL params, try to get it from localStorage
        objectId = localStorage.getItem('objectId');
    } else {
        // If objectId is found in URL params, set it in localStorage
        localStorage.setItem('objectId', objectId);
    }
    // const deeLinkURLPath = useSelector(state => state.auth.deeLinkURLPath); // your redux selector

    const handleEnterpriseDetails = async () => {
        let organizationId, id, userType;
        if (deeLinkURLPath) {
            const params = new URLSearchParams(deeLinkURLPath.split('?')[1]);
            organizationId = params.get('organizationId');
            // console.log("organizationId", organizationId)
            id = params.get('id');
            userType = params.get('type');
        }
        const userRefId = userDetails?.reference_id;
        if (organizationId && id && userType && userRefId) {
            const EnterpriseOnboardCreate = await dispatch(userOnboardByCreateLinkReducer({
                organizationId: Number(organizationId),
                userRefId: userRefId,
                userType: userType.trim().toLowerCase(),
                id: Number(id)
            }));
            // console.log("EnterpriseOnboardCreate85258", EnterpriseOnboardCreate)
            // if (EnterpriseOnboardCreate.type == userOnboardByCreateLinkReducer.fulfilled.type) {
            if (EnterpriseOnboardCreate?.payload?.success == true) {
                // console.log("NNNNNNN8686",  EnterpriseOnboardCreate?.payload?.success)
                const baseUrl = process.env.REACT_APP_ENTERPRISE_URL;
                // console.log("baseUrl123456", deepLinkURLPath !== "")
                if (deeLinkURLPath !== "") {
                    // console.log("deepLinkURLPath", deepLinkURLPath)
                    window.location.replace(`${baseUrl}/?userType=${userType}`);
                    await dispatch(setDeeplinking(""))
                }


            }

        }
    };
    useEffect(() => {
        if (deeLinkURLPath) { // Guard to avoid running on empty value
            handleEnterpriseDetails();
        }
    }, [deeLinkURLPath]);


    const [availableHeight1, Column1Ref] = useAvailableHeight(160);

    const headers = {
        'x-api-key': apiKey,
        'Content-Type': 'application/json',
        'Authorization': `Bearer ${objectId}`
    };
    const { callApiFunction } = useApi();
    axios.defaults.baseURL = `${process.env.REACT_APP_BACKEND_URL}`;
    const [profilePicturePersonal, setprofilePicturePersonal] = useState('');
    const [SocialLinks, setSocialLinks] = useState("");
    const anySocialIconsVisible = SocialLinks && SocialLinks.links?.some(link => link && link.visible);

    const [cardDetailsForPersonal, setCardDetailsForPersonal] = useState({
        User_ID: objectId,
        ProfilePicture: {
            name: '',
            type: '',
            data: ''
        },
        CompanyLogo: {
            name: '',
            type: '',
            data: ''
        },
        Designation: 'Profession',
    });
    const [activeMenu, setActiveMenu] = useState('personal_profile');

    const initialCardDetails = {
        User_ID: objectId,
        employee_id: '',
        company_id: '',
        profession_department: '',
        profession_id: '',
        company_website: '',
        is_professional_verified: false,
        professional_details_status: '',
        student_id: '',
        student_email_id: '',
        student_year: '',
        student_ending_year: '',
        student_currently_pursuing: false,
        education_level: '',
        institute: '',
        board: '',
        degree: '',
        field_of_study: '',
        grade: '',
        is_student_verified: false,
        student_details_status: '',
        CardType: 'Personal',
        prefix: '',
        suffix: '',
        title: '',
        nickname: '',
        summary: '',
        designation: '',
        company: '',
        profession_department: '',
        profile_pic: '',
        logo: ''
    };
    const apifetching2 = useRef(false);
    const percentage = 33;
    const [isHovered, setIsHovered] = useState(false);
    const truncateName = (name) => {
        if (name.length <= 6) {
            return name; // Return the name itself if its length is 6 or less
        } else {
            const maxLength = Math.floor(name.length / 2);
            const truncatedName = name.slice(0, maxLength) + "...";
            return truncatedName;
        }
    };
    const shouldShowTooltip = (name) => {
        return name.length > 6;
    };
    const [isTooltipOpen, setIsTooltipOpen] = useState(false);
    const handleTooltipToggle = () => {
        setIsTooltipOpen(!isTooltipOpen); // Toggle the tooltip on click
    };
    const handleMenuClick = (event, newValue) => {
        setActiveMenu(newValue);
    };

    return (
        <div className="d-flex align-items-start gap-3 px-5 py-3 home-page-container">

            <div className="homePage-section-one" ref={Column1Ref} style={{
                minHeight: `${availableHeight1}px`,
                display: "flex",
                flexDirection: "column",
                overflowY: "auto",
                scrollbarWidth: 'none'
            }}>

                <Tabs
                    value={activeMenu}
                    onChange={handleMenuClick}
                    aria-label="Profile Tabs"
                    // variant="scrollable"
                    // scrollButtons="auto"
                    className='custom-home-tabs mb-1'
                    selectionFollowsFocus

                >
                    <Tab
                        label="Personal"
                        value="personal_profile"
                    // onClick={handlePersonalTabClick}
                    />
                    <Tab
                        label="Professional"
                        value="professional_profile"
                    // onClick={handleProfessionalTabClick}
                    />
                    <Tab
                        label="Financial"
                        value="financel"
                    />

                </Tabs>


                <HomepageRightFeedd activeMenu={activeMenu} />

            </div>
            <div className="homePage-section-two justify-content-between gap-3" style={{
                display: "flex",
                flexDirection: "column",
                minHeight: `${availableHeight1}px`,
                overflowY: "auto",
                scrollbarWidth: 'none',
            }}>
                <HomepageMiddleFeed key={activeMenu} activeMenu={activeMenu} />



            </div>


            <div className="justify-content-between gap-3 homePage-section-three" style={{
                height: "615px",
                display: "flex",
                flexDirection: "column",
                minHeight: `${availableHeight1}px`,
                overflowY: "auto",
                scrollbarWidth: 'none'

            }}>

                <HomepageLeftFeedd activeMenu={activeMenu} />


            </div>


        </div >
    );
};
// Styled Chip to handle text truncation
const TruncatedLabel = styled('span')({
    maxWidth: '100px',
    height: '35px',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    whiteSpace: 'nowrap',
    display: 'flex',
    alignItems: 'center'
});

export default ParentHomePage;